import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withCtx as _withCtx, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/arrow-left.svg'


const _hoisted_1 = {
  key: 1,
  class: "h-full"
}
const _hoisted_2 = { class: "flex flex-row justify-between items-center border-b border-gray-lp-400" }
const _hoisted_3 = { class: "flex flex-row my-4" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-20px mr-4 text-black-lp-200" }, " Edit Versi ", -1)
const _hoisted_5 = { class: "inline-flex" }
const _hoisted_6 = {
  key: 2,
  class: "flex flex-row h-full pb-4"
}
const _hoisted_7 = {
  class: "w-full px-4 text-12px xxl:text-14px pb-24 overflow-y-auto",
  style: {"padding-right":"50%"}
}
const _hoisted_8 = { class: "pt-4" }
const _hoisted_9 = { class: "py-2 w-3/4" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Nama Versi", -1)
const _hoisted_11 = { class: "py-3 w-3/4" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, "Total Route", -1)
const _hoisted_13 = { class: "py-4 border-t border-gray-lp-400" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }, " Periode Harga ", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Harga akan aktif sesuai dengan tanggal periode yang dipilih. ", -1)
const _hoisted_16 = { class: "flex gap-x-4" }
const _hoisted_17 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_18 = { class: "text-red-lp-100 text-12px xxl:text-14px" }
const _hoisted_19 = { class: "pt-3 w-3/4" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 mb-2" }, " Berkas Lampiran ", -1)
const _hoisted_21 = { class: "py-4 border-t border-gray-lp-400 w-3/4" }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "pt-2 text-12px xxl:text-14px text-gray-lp-300 font-semibold" }, " Status Publish Version Rates ", -1)
const _hoisted_23 = /*#__PURE__*/_createVNode("div", { class: "my-1 text-gray-lp-500" }, " Status version rates yang diaktfikan akan menjadi publish for sale. Version rates yang sudah diaktifkan tidak dapat diubah kembali. ", -1)
const _hoisted_24 = { class: "my-2 flex flex-row text-12px xxl:text-14px items-center text-black-lp-300" }
const _hoisted_25 = { class: "ml-4" }
const _hoisted_26 = {
  class: "w-1/3 px-8 text-12px xxl:text-14px border-l border-gray-lp-400 mt-4",
  style: {"margin-left":"-35%"}
}
const _hoisted_27 = { class: "py-3" }
const _hoisted_28 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Status Versi ", -1)
const _hoisted_29 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_30 = { class: "flex" }
const _hoisted_31 = { class: "capitalize" }
const _hoisted_32 = { class: "py-3" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Tanggal Dibuat ", -1)
const _hoisted_34 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_35 = { class: "text-gray-lp-500" }
const _hoisted_36 = { class: "py-3" }
const _hoisted_37 = /*#__PURE__*/_createVNode("div", { class: "font-semibold text-black-lp-300 text-12px xxl:text-14px" }, " Terakhir Diubah ", -1)
const _hoisted_38 = { class: "my-1 text-black-lp-300 text-12px xxl:text-14px font-normal" }
const _hoisted_39 = { class: "text-gray-lp-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageDetailLazyLoad = _resolveComponent("PageDetailLazyLoad")!
  const _component_button_fill = _resolveComponent("button-fill")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_DatePickers = _resolveComponent("DatePickers")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_download_attachment = _resolveComponent("download-attachment")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_PageDetailLazyLoad, {
          key: 0,
          onBack: _ctx.goBack
        }, null, 8, ["onBack"]))
      : (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("img", {
                src: _imports_0,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
                class: "w-5 mr-3 cursor-pointer",
                alt: "back"
              }),
              _hoisted_4
            ]),
            _createVNode("div", _hoisted_5, [
              (!_ctx.isError)
                ? (_openBlock(), _createBlock(_component_button_fill, {
                    key: 0,
                    title: "Simpan",
                    onClick: _ctx.onOpenSave,
                    class: "px-8 bg-red-lp-300",
                    isDisabled: _ctx.isDisabled || !_ctx.isRatesStatus
                  }, null, 8, ["onClick", "isDisabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.isErrorEdit)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 0,
                onCancel: _ctx.handleErrorClose,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx._onEdit,
                modal: ""
              }, null, 8, ["onCancel", "errorType", "onTryAgain"]))
            : _createCommentVNode("", true),
          (_ctx.isError)
            ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                key: 1,
                errorType: _ctx.errorCause,
                onTryAgain: _ctx.getDetail
              }, null, 8, ["errorType", "onTryAgain"]))
            : (_openBlock(), _createBlock("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("div", _hoisted_8, [
                    _createVNode("div", _hoisted_9, [
                      _hoisted_10,
                      _withDirectives(_createVNode("textarea", {
                        class: "\n                py-1.5 xxl:py-3 px-4 rounded border bg-white border-gray-lp-400 focus:outline-none focus:shadow w-full resize-none text-gray-lp-600",
                        rows: "2",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.detailData.rateVersionName = $event)),
                        disabled: true
                      }, null, 512), [
                        [_vModelText, _ctx.detailData.rateVersionName]
                      ])
                    ]),
                    _createVNode("div", _hoisted_11, [
                      _hoisted_12,
                      _withDirectives(_createVNode("input", {
                        class: 
                `block appearance-none text-12px xxl:text-14px w-full bg-white border border-gray-lp-400 px-4 py-2 pr-16 rounded leading-tight focus:outline-none text-gray-lp-600`
              ,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.detailData.rateVersionTotalRoute = $event)),
                        disabled: true
                      }, null, 512), [
                        [_vModelText, _ctx.detailData.rateVersionTotalRoute]
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _hoisted_15,
                    _createVNode("div", _hoisted_16, [
                      _createVNode(_component_DataWrapper, {
                        label: "Dimulai Dari",
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePickers, {
                            modelValue: _ctx.periodeStart,
                            onSelected: _ctx.inputDateStart,
                            minDate: 
                  new Date(
                    _ctx.$moment()
                      .add(1, 'days')
                      .toISOString()
                  )
                ,
                            class: "my-2",
                            disabled: ""
                          }, null, 8, ["modelValue", "onSelected", "minDate"]),
                          _withDirectives(_createVNode("div", _hoisted_17, " Tanggal mulai tidak boleh lebih dari tanggal akhir ", 512), [
                            [_vShow, _ctx.invalidStartDate]
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_DataWrapper, {
                        label: "Sampai",
                        class: "w-6/12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DatePickers, {
                            modelValue: _ctx.periodeEnd,
                            onSelected: _ctx.inputDateEnd,
                            minDate: 
                  new Date(
                    _ctx.$moment(_ctx.periodeStart)
                      .add(1, 'days')
                      .toISOString()
                  )
                ,
                            class: "my-2",
                            disabled: ""
                          }, null, 8, ["modelValue", "onSelected", "minDate"]),
                          _withDirectives(_createVNode("div", _hoisted_18, " Tanggal akhir tidak boleh kurang dari tanggal mulai ", 512), [
                            [_vShow, _ctx.invalidEndDate]
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _createVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createVNode(_component_download_attachment, {
                        name: _ctx.detailData.rateVersionFiledUpload,
                        url: _ctx.detailData.rateVersionFiledUpload,
                        maxLength: 45,
                        class: "my-2 text-gray-lp-300"
                      }, null, 8, ["name", "url"])
                    ])
                  ]),
                  _createVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _hoisted_23,
                    _createVNode("div", _hoisted_24, [
                      _createVNode(_component_Toggle, {
                        onChange: 
                () =>
                  _ctx.isRatesStatus ? _ctx.changeRatesStatus() : _ctx.onOpenRatesStatus(true)
              ,
                        isActive: _ctx.isRatesStatus
                      }, null, 8, ["onChange", "isActive"]),
                      _createVNode("div", _hoisted_25, " Version Rates " + _toDisplayString(_ctx.isRatesStatus ? "Publish For Sales" : "Tidak Aktif"), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_26, [
                  _createVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createVNode("div", _hoisted_29, [
                      _createVNode("div", _hoisted_30, [
                        _createVNode("div", {
                          class: 
                  `rounded-full px-2 py-0 font-medium ${
                    _ctx.detailData.rateVersionStatus.toLowerCase() === 'active' ||
                    _ctx.detailData.rateVersionStatus.toLowerCase() === 'for-sales'
                      ? 'bg-green-lp-300'
                      : _ctx.detailData.rateVersionStatus.toLowerCase() ===
                          'expired' ||
                        _ctx.detailData.rateVersionStatus.toLowerCase() ===
                          'inactive'
                      ? 'bg-red-lp-600'
                      : 'bg-gray-lp-200'
                  } ${
                    _ctx.detailData.rateVersionStatus.toLowerCase() === 'active' ||
                    _ctx.detailData.rateVersionStatus.toLowerCase() === 'for-sales'
                      ? 'text-green-lp-200'
                      : _ctx.detailData.rateVersionStatus.toLowerCase() ===
                          'expired' ||
                        _ctx.detailData.rateVersionStatus.toLowerCase() ===
                          'inactive'
                      ? 'text-red-lp-500'
                      : 'text-gray-lp-300'
                  }`
                
                        }, [
                          _createVNode("span", _hoisted_31, _toDisplayString(_ctx.capitalize(_ctx.detailData.rateVersionStatus)), 1)
                        ], 2)
                      ])
                    ])
                  ]),
                  _createVNode("div", _hoisted_32, [
                    _hoisted_33,
                    _createVNode("div", _hoisted_34, _toDisplayString(_ctx.formatDate(_ctx.detailData.rateVersionCreatedAt)), 1),
                    _createVNode("div", _hoisted_35, _toDisplayString(_ctx.detailData.rateVersionCreatedBy), 1)
                  ]),
                  _createVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createVNode("div", _hoisted_38, _toDisplayString(_ctx.formatDate(
                _ctx.detailData.rateVersiondUpdatedAt ||
                  _ctx.detailData.rateVersionCreatedAt
              )), 1),
                    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.detailData.rateVersiondUpdatedBy), 1)
                  ])
                ])
              ]))
        ])),
    _withDirectives(_createVNode(_component_Modal, {
      onClose: () => _ctx.onOpenRatesStatus(false),
      onSubmit: _ctx.changeRatesStatus,
      title: "Yakin Ingin Mengubah Status?",
      message: " Saat status menjadi publish for sales, Anda tidak akan dapat mengubah informasi detail mengenai version rate ini lagi",
      image: "warning",
      textSuccess: "Ubah Status",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onClose", "onSubmit"]), [
      [_vShow, _ctx.openRatesStatus]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.goBack,
      title: "Perubahan Disimpan",
      message: `Detail Versi “${_ctx.detailData.rateVersionName}” berhasil diubah`,
      image: "image-modal-success",
      textSuccess: "Oke",
      class: "px-8"
    }, null, 8, ["onSubmit", "message"]), [
      [_vShow, _ctx.openSuccess]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx.handlerClose,
      onClose: _ctx.handlerCancelClose,
      title: "Yakin ingin keluar?",
      message: "Pastikan kembali, Anda akan kehilangan semua data jika Anda keluar halaman ini.",
      image: "are-you-sure",
      textSuccess: "Keluar",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose"]), [
      [_vShow, _ctx.isEditTerminated]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      onSubmit: _ctx._onEdit,
      onClose: _ctx.onCloseSave,
      title: "Konfirmasi Perubahan Detail Versi",
      message: 
      `Anda yakin akan menyimpan perubahan untuk versi “${_ctx.detailData.rateVersionName}”`
    ,
      image: "are-you-sure",
      textSuccess: "Simpan",
      textCancel: "Kembali",
      class: "px-8"
    }, null, 8, ["onSubmit", "onClose", "message"]), [
      [_vShow, _ctx.openSave]
    ])
  ], 64))
}